import React from "react";
import { FinancialOverview } from "../../../components/super-admin-dashboard";
import styles from "../SuperAdminDashboardPage.module.css";
import TocaBillableOverview from "../../../components/super-admin-dashboard/clientbillingoverview/TocaBillableoverview";

const FinancialsTab = ({ scope }) => {
  return (
    <div className={styles.financialContainer}>
      <FinancialOverview scope={scope} title="Client Billing Overview" />

      <TocaBillableOverview scope={scope} />

      {/* <SectionWrapper title="TOCA Billing Overview">
        <div className={styles.kpiGrid}>
          <KPICardWithTrend
            title="Total Revenue"
            value="$127,450"
            style={{ background: "#e8f5ee", borderColor: "#cfe9d9" }}
          />
          <KPICardWithTrend
            title="Billable Patients"
            value="189"
            style={{ background: "#eaf3ff", borderColor: "#d7e6ff" }}
          />
          <KPICardWithTrend
            title="Avg Revenue/Patient"
            value="$674"
            style={{ background: "#eaf6ff", borderColor: "#d7ecff" }}
          />
          <KPICardWithTrend
            title="Appealed Claims"
            value="547"
            style={{ background: "#f8fafc", borderColor: "#eef2f7" }}
          />
        </div>
      </SectionWrapper> */}
    </div>
  );
};

export default FinancialsTab;
